import React from "react";

import { Text } from "@performyard/py-components";

import FormattedDateTime from "../../../../../../../components/FormattedDateTime";

import { useSurvey } from "../../../hooks/useSurvey";
import { useSurveyEmailStatus } from "../hooks/useSurveyEmailStatus";

import { getStatusChip } from "../../../../../utils";

export const SurveyResultsHeader = ({ surveyId }: { surveyId: string }) => {
	const { survey } = useSurvey({ surveyId });

	const disabledEmailStatus = survey?.status === "draft" || survey?.status === "closed";

	const { emailScheduled, scheduledTime, scheduledInTheFuture } = useSurveyEmailStatus(surveyId, disabledEmailStatus);

	const dateDisplay = (
		<>
			{survey?.startDate && !survey?.endDate && (
				<div className="flex flex-row items-center gap-2">
					<Text size="paragraph-3" weight="semi-bold">
						Start Date:
					</Text>
					<FormattedDateTime
						size="paragraph-3"
						date={new Date(survey.startDate)}
						dateSize="large"
						hasTime={true}
						formatString="MMM d, yyyy h:mma"
					/>
				</div>
			)}
			{survey?.startDate && survey?.endDate && (
				<div className="flex flex-row items-center gap-2">
					<Text size="paragraph-3" weight="semi-bold">
						Start and End Date:
					</Text>
					<div className="flex flex-row items-center gap-1">
						<FormattedDateTime
							size="paragraph-3"
							date={new Date(survey.startDate)}
							formatString="MMM d, yyyy h:mma"
							dateSize="large"
							hasTime={true}
						/>
						-
						<FormattedDateTime
							size="paragraph-3"
							date={new Date(survey.endDate)}
							formatString="MMM d, yyyy h:mma"
							dateSize="large"
							hasTime={true}
						/>
					</div>
				</div>
			)}
			{emailScheduled && scheduledTime && scheduledInTheFuture && (
				<div className="flex flex-row items-center gap-2">
					<Text size="paragraph-3" weight="semi-bold">
						Email:
					</Text>
					<Text size="paragraph-3" weight="regular">
						<div className="flex flex-row items-center gap-1">
							Scheduled to be sent
							<FormattedDateTime
								size="paragraph-3"
								date={scheduledTime}
								dateSize="large"
								hasTime={true}
								formatString="MMM d, yyyy h:mma"
							/>
						</div>
					</Text>
				</div>
			)}
		</>
	);

	return (
		<div data-testid="survey-results-header" className="w-100 mt-6 flex items-start justify-between">
			{/* Survey Info */}
			<div className="flex w-[calc(100%-180px)] flex-1 flex-col gap-2">
				<Text size="heading-5" weight="semi-bold">
					{survey?.name}
				</Text>
				<div data-testid="survey-status" className="flex flex-row items-center gap-2">
					<Text size="paragraph-3" weight="semi-bold">
						Status:
					</Text>
					{survey?.status && getStatusChip(survey?.status)}
				</div>
				{dateDisplay}
			</div>
		</div>
	);
};
